import { ModuleRightType } from 'constants/rights';

export const settingRights: ModuleRightType = {
  SETTING: {
    ACCESS: 'SETTING.ACCESS',
  },
};
